import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { VolumeComposite } from "@/domains/analytics/components/volume/volume-composite"
import { createBreadcrumbItem } from "@/domains/diagnostics/utils/breadcrumb-helpers"
import { AnalyticsPagesComplexBreadcrumbApplication } from "@/domains/navigation/components/complex-breadcrumb-applications/analytics-pages-complex-breadcrumb-application"

const BREADCRUMB_ITEMS = [
  createBreadcrumbItem("more", "More", "/"),
  createBreadcrumbItem("analytics", "Analytics", "/analytics"),
  AnalyticsPagesComplexBreadcrumbApplication,
]

export default function AnalyticsVolumePage() {
  return (
    <PageContainer>
      <MetaData title="Volume | Analytics" />
      <PageTitle
        title="Volume"
        subTitle="Platform volume analytics"
        items={BREADCRUMB_ITEMS}
      />
      <VolumeComposite />
    </PageContainer>
  )
}
